import React, { useRef, useEffect } from "react";
import vedio from "../CubeGame/vedio.mp4";

const Cube = ({ onVideoStop }) => {
  const videoRef = useRef(null);

  const targetTime = 8.5; // seconds → adjust to when the yellow cube stops

  const handleTimeUpdate = () => {
    if (videoRef.current.currentTime >= targetTime) {
      videoRef.current.pause();
      onVideoStop(); // notify parent to display questions
    }
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);

  return (
    <div className="w-[800px] h-[500px] rounded-2xl overflow-hidden shadow-2xl backdrop-blur-lg bg-white/10 border border-white/20 p-1">
      <video
        ref={videoRef}
        src={vedio}
        onTimeUpdate={handleTimeUpdate}
        muted
        className="w-full h-full object-cover rounded-xl"
      />
    </div>
  );
};

export default Cube;
